const initialState = {
  pending: null,
  chosenItems: [],
  items: [],
};

export default function recorderTemplates(state = initialState, action) {
  switch (action.type) {
    case 'GET_RECORDER_TEMPLATES_START':
      return {
        ...state,
        ...{ pending: true }
      };
    case 'GET_RECORDER_TEMPLATES_COMPLETE':
      return {
        ...state, ...{
          pending: false,
          items: action.payload.response
      }};
    case 'GET_RECORDER_TEMPLATES_FAIL':
    case 'GET_RECORDER_TEMPLATES_FAIL_PARSE':
    case 'GET_RECORDER_TEMPLATES_FAIL_REQUEST':
      return {
        ...state,
        pending: false,
        items: []
      };
    case 'CHOOSE_RECORDER_TEMPLATE':
      var chosenIndex = state.items.findIndex((item) => {
        return item.id === action.payload.id;
      });

      if (chosenIndex === -1) {
        console.warn('Chosen unexist template. Id: ' + action.payload.id);
        return state;
      }

      return {
        ...state,
        ...{ chosenItems: [state.items[chosenIndex]] }
      };
    case 'RECORDER_TEMPLATE_CHOSEN':
      var indexToChoose = state.items.findIndex((item) => {
        return item.id === action.payload.id;
      });

      if (indexToChoose === -1) {
        console.warn('Chosen unexist template. Id: ' + action.payload.id);
        return state;
      }

      var indexInChosen = state.chosenItems.findIndex((item) => {
        return item.id === action.payload.id;
      });

      // already chosen
      if (indexInChosen !== -1) {
        return state;
      }

      state.chosenItems.push(state.items[indexToChoose])
      return {
        ...state,
      };
    case 'RECORDER_TEMPLATE_UNCHOSEN':
      var indexToUnchoose = state.chosenItems.findIndex((item) => {
        return item.id === action.payload.id;
      });

      if (indexToChoose === -1) {
        return state;
      }

      state.chosenItems.splice(indexToUnchoose, 1);
      return {
        ...state
      };
    case 'CLEAR_RECORDER_TEMPLATES':
      return initialState;
    default:
      return state;
  }
}
